/**
 * 실데이터 피드: 스냅샷 API 를 주기적으로 폴링해 화면 스냅샷으로 조립한다.
 *
 * - 시작 즉시 한 번 받고, 이후 intervalMs 마다 반복한다. 응답이 늦어 겹치면 다음 틱은 건너뛴다.
 * - 일시정지(setPaused) 중에는 요청을 보내지 않는다(마지막 화면 유지).
 * - 실패하면 onError 로 알리고 마지막 스냅샷을 그대로 둔다. 가짜 데이터로 대체하지 않는다.
 */
import { buildLiveSnapshot } from "./live-snapshot";

export const DEFAULT_INTERVAL_MS = 5000;

export class PipelineFeed {
    constructor({ fetchSnapshot, onSnapshot, onError, intervalMs = DEFAULT_INTERVAL_MS }) {
        this.fetchSnapshot = fetchSnapshot;
        this.onSnapshot = onSnapshot;
        this.onError = onError;
        this.intervalMs = intervalMs;
        this.timer = null;
        this.paused = false;
        this.inFlight = false;
        this.stopped = false;
    }

    start() {
        this.stopped = false;
        this.tick();
        this.timer = setInterval(() => this.tick(), this.intervalMs);
    }

    stop() {
        this.stopped = true;
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
    }

    setPaused(paused) {
        this.paused = !!paused;
        if (!this.paused) this.tick();
    }

    /** 오류 배너의 "재시도" — 일시정지 여부와 무관하게 즉시 한 번 받는다 */
    refresh() {
        this.tick(true);
    }

    async tick(force = false) {
        if (this.stopped || this.inFlight || (this.paused && !force)) return;
        this.inFlight = true;
        const t0 = performance.now();
        try {
            const api = await this.fetchSnapshot();
            if (this.stopped) return;
            const snapshot = buildLiveSnapshot(api);
            this.onSnapshot(snapshot, { fetchMs: Math.round(performance.now() - t0) });
        } catch (err) {
            if (!this.stopped) this.onError(err?.message ?? String(err));
        } finally {
            this.inFlight = false;
        }
    }
}
